module.exports = __webpack_public_path__ + "img/m-churukushenqing.d1a7faf3.svg";